// extracted by mini-css-extract-plugin
export default {"container":"footer_container__s-AWq","row":"footer_row__jO-1c","main":"footer_main__Tv5qP"};